import { DeviceBehfa_Interface } from './DeviceBehfa_Interface';
import { Device_MANUFACTURE_Interface } from './Device_MANUFACTURE_Interface';

export interface Calibration_Interface {
  id:number,
  parent:number,
  device_id:number,
  device_name:String,
  kala_code:string,
  device_code:string,
  device_serial:string,
  expiration:number,
  expiration_title:String,
  priority:number,
  priority_title:string,
  priod:number,
  labAdderss:string,
  dsc:string,
  asteghrar:string,
  visible:boolean,
  persianDate:string,

  status: number,
  expert_off: number,
  canEditDetail: number,

  tEMPERATURE_MIN:number,
  tEMPERATURE_MAX:number,
  tEMPERATURE_Vahed_id:number,
  tEMPERATURE_Vahed_Title:String,

  rELATIVE_HUMIDITY_MIN:number,
  rELATIVE_HUMIDITY_MAX:number,
  rELATIVE_HUMIDITY_Vahed_id:number,
  rELATIVE_HUMIDITY_Vahed_Title:String,

  aTMOSPHERIC_PRESSURE_MIN:number,
  aTMOSPHERIC_PRESSURE_MAX:number,
  aTMOSPHERIC_PRESSURE_Vahed_id:number,
  aTMOSPHERIC_PRESSURE_Vahed_Title:String,
  
  display_linearity:number,

  manufactureData:Array<any>
  deviceBehfa:Array<DeviceBehfa_Interface>

  showDeviceBehfa:boolean,
  child:Array<Calibration_Interface>
}

export function Empty_Calibration_Interface():Calibration_Interface{
  return{
    id:0,
    parent:0,
    device_id:0,
    device_name:'',
    kala_code:'',
    device_code:'',
    device_serial:'',
    expiration:0,
    expiration_title:'',
    priority:0,
    priority_title:'',
    priod:0,
    dsc:'',
    asteghrar:'',
    persianDate:'',
    labAdderss:'',
    visible: false,

    status: 0,
    expert_off: 0,
    canEditDetail: 0,
    
    display_linearity: 0,

    tEMPERATURE_MIN:0,
    tEMPERATURE_MAX:0,
    tEMPERATURE_Vahed_id:0,
    tEMPERATURE_Vahed_Title:'',

    rELATIVE_HUMIDITY_MIN:0,
    rELATIVE_HUMIDITY_MAX:0,
    rELATIVE_HUMIDITY_Vahed_id:0,
    rELATIVE_HUMIDITY_Vahed_Title:'',

    aTMOSPHERIC_PRESSURE_MIN:0,
    aTMOSPHERIC_PRESSURE_MAX:0,
    aTMOSPHERIC_PRESSURE_Vahed_id:0,
    aTMOSPHERIC_PRESSURE_Vahed_Title:'',

    showDeviceBehfa:false,
    manufactureData:[],
    deviceBehfa:[],
    child:[],
  }
}
